import { yupResolver } from "@hookform/resolvers/yup";
import { HStack, View } from "native-base";
import React from "react";
import { useForm } from "react-hook-form";
import { TextInputMask } from "react-native-masked-text";

import FormButton from "@/components/atoms/FormButton";
import SecureTextInput from "@/components/atoms/SecureTextInput";
import TermsButton from "@/components/atoms/TermsButton";
import TextInput from "@/components/atoms/TextInput";
import FormField from "@/components/molecules/FormField";

import { SignUpFormComponentProps } from "../../types";
import { CustomerFormData, schema } from "../schema";

type FormProps = SignUpFormComponentProps<CustomerFormData>;

const Form = ({ isSubmiting, onCancel, onSubmit }: FormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<CustomerFormData>({
    resolver: yupResolver(schema),
  });

  return (
    <View w="full">
      <FormField
        control={control}
        name="nome"
        label="Nome completo"
        required
        error={errors.nome}
        render={(value, onChange) => (
          <TextInput value={value} onChangeText={onChange} placeholder="Nome completo" />
        )}
      />
      <HStack w="1/2" space={2}>
        <FormField
          control={control}
          name="telefone"
          label="Telefone"
          required
          error={errors.telefone}
          render={(value, onChange) => (
            <TextInputMask
              value={value}
              onChangeText={onChange}
              customTextInput={TextInput}
              type={"cel-phone"}
              options={{
                maskType: "BRL",
                withDDD: true,
                dddMask: "(99) ",
              }}
              placeholder="Telefone"
            />
          )}
        />
        <FormField
          control={control}
          name="dataNascimento"
          label="Data de nascimento"
          error={errors.dataNascimento}
          render={(value, onChange) => (
            <TextInputMask
              value={value}
              onChangeText={onChange}
              customTextInput={TextInput}
              includeRawValueInChangeText={true}
              type={"datetime"}
              options={{
                format: "DD/MM/YYYY",
              }}
              placeholder="Data de nascimento"
            />
          )}
        />
      </HStack>
      <FormField
        control={control}
        name="email"
        label="E-mail"
        required
        error={errors.email}
        render={(value, onChange) => (
          <TextInput value={value} onChangeText={onChange} placeholder="E-mail" />
        )}
      />
      <FormField
        control={control}
        name="emailConfirm"
        label="Confirme o E-mail"
        required
        error={errors.emailConfirm}
        render={(value, onChange) => (
          <TextInput
            value={value}
            keyboardType="email-address"
            autoCapitalize="none"
            onChangeText={onChange}
            placeholder="Confirme o E-mail"
          />
        )}
      />
      <FormField
        control={control}
        name="senha"
        label="Senha"
        hint="Pelo menos 8 caracteres com letras e números"
        required
        error={errors.senha}
        render={(value, onChange) => (
          <SecureTextInput
            value={value}
            autoCapitalize="none"
            onChangeText={onChange}
            placeholder="Senha"
          />
        )}
      />
      <FormField
        control={control}
        name="senhaConfirm"
        label="Confirma e senha"
        hint="Pelo menos 8 caracteres com letras e números"
        required
        error={errors.senhaConfirm}
        render={(value, onChange) => (
          <SecureTextInput
            value={value}
            autoCapitalize="none"
            onChangeText={onChange}
            placeholder="Confirma e senha"
          />
        )}
      />
      <FormButton mt="10" isLoading={isSubmiting} onPress={handleSubmit(onSubmit)}>
        Cadastrar
      </FormButton>
      <FormButton
        colorScheme="white"
        textColor="primary.700"
        my="4"
        shadow="2"
        onPress={() => onCancel()}>
        Cancelar
      </FormButton>
      <TermsButton />
    </View>
  );
};

export default Form;
